export function prefixWithPipe(label: string): string {
    if (!label) {
        return "";
    }
    return " | " + label;
}